import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import { px2rem, StyledH2, StyledH5 } from '../../../theme/Global'

export const CustomTitle = styled(StyledH2)`
  margin-top: 17px;
  margin-bottom: 17px;
  text-align: left;
`

export const CustomH5 = styled(StyledH5)`
  text-align: left;
`

export const LocationDetailWrapper = styled(Paper)`
  padding: ${px2rem(22)}rem 0 ${px2rem(22)}rem;
  padding-left: ${px2rem(51)}rem;
  padding-right: ${px2rem(52)}rem;
  overflow-y: auto;
  height: calc(100vh - ${px2rem(230)}rem);
`

export const Subheading = styled(StyledH5)`
  margin: 0.6rem 0;
  padding: 0;
  text-align: left;
`

export const StyledHeader = styled(StyledH5)`
  margin-left: 20px;
  font-size: 13.5pt;
  font-weight: 600;
  text-align: left;
`
